var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offset-sm-1 col-sm-9 col-10 offset-1 system-settings"},[_c('div',{staticClass:"system-settings-content"},[_c('JobPostingAutoDisplay'),_c('DomainIpSettings')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }